import React, { useState, memo } from 'react';
import styled from 'styled-components';
import { OverlayTrigger, Popover, Table, Alert, Form } from '../ui-kit';
import { IconSpinner, IconExclamationTriangle } from '../ui-kit/icons';
import Loader from '../general/Loader';
import { formatTime } from '../../utils/time';
import moment from 'moment';

const CenteredCell = styled.div`
  text-align: center;
`;

const SkillAuditTable = ({ certifications, anyFuture }) => (
  <>
    {anyFuture && <Alert variant="warning">{I18n.t('skills.future_certifications_warning')}</Alert>}
    <Table bordered condensed className="p-0 m-0">
      <thead>
        <tr>
          <th>{I18n.t('activerecord.attributes.certification.start_time')}</th>
          <th>{I18n.t('activerecord.attributes.certification.end_time')}</th>
        </tr>
      </thead>
      <tbody>
        {certifications.length === 0 && (
          <tr>
            <td colSpan="2">{I18n.t('no_results_found')}</td>
          </tr>
        )}
        {certifications &&
          certifications.map(c => (
            <tr key={c.id}>
              <td>{formatTime(c.start_time)}</td>
              <td>{formatTime(c.end_time) || <i>{I18n.t('not_applicable')}</i>}</td>
            </tr>
          ))}
      </tbody>
    </Table>
  </>
);

const SkillCheckboxTableCell = ({ certifications, membershipId, skillId, userName, skillName, assignSkill }) => {
  const [loading, setLoading] = useState(false);

  const now = moment();

  const popover = (
    <Popover id={membershipId} style={{ width: anyFutureCertifications ? '450px' : '250px' }}>
      <Popover.Header>{I18n.t('skills.audit') + ' - ' + userName + '\n' + skillName}</Popover.Header>
      <Popover.Body className="p-1">
        {!certifications && <Loader />}
        {certifications && <SkillAuditTable certifications={certifications} anyFuture={anyFutureCertifications} />}
      </Popover.Body>
    </Popover>
  );

  // Returns true iff there are any changes to certifications scheduled for the
  // future. This means that a skill will start or be revoked in the future
  const anyFutureCertifications = certifications.some(
    c => now.isBefore(c.start_time) || (c.end_time && now.isBefore(c.end_time))
  );

  const checked = certifications.some(c =>
    c.end_time ? now.isBetween(c.start_time, c.end_time) : now.isAfter(c.start_time)
  );

  const toggleChecked = async () => {
    setLoading(true);
    await assignSkill(membershipId, skillId, !checked);
    setLoading(false);
  };

  return (
    <CenteredCell onClick={toggleChecked}>
      {loading && <IconSpinner spin />}
      {!loading && (
        <OverlayTrigger overlay={popover}>
          <span>
            <Form.Check checked={checked} /> {anyFutureCertifications && <IconExclamationTriangle />}
          </span>
        </OverlayTrigger>
      )}
    </CenteredCell>
  );
};

export default memo(SkillCheckboxTableCell);
